import React from "react";
import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";

const Home = ({ setLogged, logged }) => {
	const username = JSON.parse(localStorage.getItem("username"));
	return (
		<div className="h-full pb-3 bg-gray-100">
			{logged ? (
				<>
					<Navbar setLogged={setLogged} />
					<div className="text-right text-gray-800 mr-10">
						{username ? `Usuario: ${username}` : null}
					</div>
				</>
			) : null}
			<Outlet />
		</div>
	);
};

export default Home;
